export enum SecureStorageEnum {
  accessToken = 'accessToken',
  refreshToken = 'refreshToken'
}

export interface ILogin {
  phone: string;
  password: string;
}
